import React from 'react'

function ForgotPassword() {
  return (

    <>
      {/* strat content */}
      <div className="flex flex-row justify-center items-center bg-gray-100 md:mt-16 p-6 w-full h-screen">

        <div className="space-y-8 bg-white px-4 py-6 rounded-md w-full max-w-sm">
          <h1 className="font-semibold text-center text-xl">Réinitialisation de mot de passe</h1>
          <p className="font-medium text-center text-gray-500 text-sm">
            <ul className='space-y-2'>
              <li>Vous avez oublé votre mot de passe ? </li>
              <li>Ici, vous pouvez facilement récupérer un nouveau mot de passe.</li>
            </ul>
          </p>
          <form action="#" className="space-y-8">
            <input
              className="dark:border-gray-700 dark:bg-darker px-4 py-2 border rounded-md focus:ring focus:ring-primary-100 dark:focus:ring-primary-darker w-full focus:outline-none"
              type="email"
              name="email"
              placeholder="Saisissez votre email"
              required
            />
            <div>
              <button
                type="submit"
                className="bg-red-800 px-4 py-2 rounded-md focus:ring-2 focus:ring-primary focus:ring-offset-1 dark:focus:ring-offset-darker w-full font-medium text-center text-white transition-colors duration-200 focus:outline-none"
              >
                Demander un mot de passe
              </button>
            </div>
          </form>

          <div className="flex flex-nowrap justify-center items-center space-x-2">
            <span className="bg-gray-300 w-20 h-px"></span>
            <span>OU</span>
            <span className="bg-gray-300 w-20 h-px"></span>
          </div>

          <div className="text-gray-600 text-sm dark:text-gray-400">
            <a href="/reset-password" className="text-teal-500 hover:underline"> Réinitialiser le mot de passe </a>
          </div>
        </div>


      </div>
      {/* end content */}
    </>
  )
}

export default ForgotPassword